import { Component, OnInit } from '@angular/core';
import { PopulationQuery } from '@fgb/core';

@Component({
  selector: 'fgb-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor(private populationQuery: PopulationQuery) {}
  isKid: boolean;
  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation(['Kids']);
  }
}
